import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import useTracking, { TrackingFnType } from './useTracking'

type UseToggleMenuVisibilityType = () => {
  openBurgerMenu: () => void
  closeBurgerMenu: (resetScrollPosition: boolean) => void
}

const useToggleMenuVisibility: UseToggleMenuVisibilityType = () => {
  const queryClient = useQueryClient()

  const openBurgerMenuTrackingFn = useCallback<TrackingFnType>(
    () => ({
      event: 'navigation_expand',
      eventCategory: 'Navigation',
      eventAction: 'expand',
      eventLabel: '',
    }),
    [],
  )

  const onOpenBurgerMenuClick = useTracking(openBurgerMenuTrackingFn)

  const openBurgerMenu = useCallback(() => {
    // ...and track the opening of the burger menu
    onOpenBurgerMenuClick()

    queryClient.setQueryData(['burgerMenuVisibility'], {
      isVisible: true,
      resetScrollPosition: true,
    })
    queryClient.invalidateQueries({ queryKey: ['burgerMenuVisibility'] })
  }, [queryClient, onOpenBurgerMenuClick])

  const closeBurgerMenu = useCallback(
    (resetScrollPosition: boolean) => {
      queryClient.setQueryData(['burgerMenuVisibility'], {
        isVisible: false,
        resetScrollPosition: resetScrollPosition,
      })
      queryClient.invalidateQueries({ queryKey: ['burgerMenuVisibility'] })
    },
    [queryClient],
  )

  return {
    openBurgerMenu,
    closeBurgerMenu,
  }
}

export default useToggleMenuVisibility
